import { createKeys, createCrud } from '../../CRUD';
import { TPatientMessageTemplate } from './types';

export const patientMessageTemplateKeys = createKeys(
  'patientMessageTemplates',
  'PatientMessageTemplate',
);

export const patientMessageTemplateBaseModel =
  createCrud<TPatientMessageTemplate>(
    'patientMessageTemplates',
    'PatientMessageTemplate',
  );
